<template lang="pug">
    v-container
        v-toolbar(card='' dark='' :color='colors.info' )
            v-toolbar-title.white--text ARQUEO CAJA
        v-card
            v-layout.pa-2(row wrap)
                v-flex(md6 xs12)
                    information-summaries
                v-flex.box(md6 xs12 align-content-center)
                    modal-supervisor(
                        :available="showModal" 
                        title="Codigo Supervisor"  
                        :showModal="openModal"
                        @check-key="checkKey"
                        confirmMessage="(F8) Generar Arqueo"
                    )
            //total-summaries.mt-3(v-if ="showTotalPaymentSummaries")
</template>

<script>
import InformationSummaries from '@/views/PaymentSummaries/InformationSummaries'
import TotalDetailSummaries from '@/views/PaymentSummaries/TotalDetailSummaries'
import ModalSupervisor from '@/components/SupervisorUniqueKey/Modal'

import { mapState, mapActions } from 'vuex'
import { log } from 'util'
import { arrayExpression } from 'babel-types'
import {
    replacePropertyNames,
    arrayToFrontEndFormat,
    objectToBackendFormat,
    objectToFrontEndFormat,
} from '@/services/ObjectFormatter'
import {
    responseCustomerFormat,
    responseEmployeeFormat,
    responseEgressTotal,
    customerTotalResponse,
    employeeTotalResponse,
} from '@/services/API/paymentSummaries/formatData'

export default {
    name: 'payment-summaries',
    props: {},
    data: function() {
        return {
            showModal: true,
            openModal: false,
            showTotalPaymentSummaries: false,
        }
    },
    computed: {
        ...mapState('UniqueKeyModule', {
            uniqueKey: 'uniqueKey',
        }),
        ...mapState('AuthModule', {
            posCashDeskId: state => state.cash_desk_id,
        }),
    },
    methods: {
        ...mapActions('UniqueKeyModule', {
            setPermission: 'setPermission',
            authorize: 'authorize',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
        }),
        ...mapActions('PaymentSummariesModule', {
            getPaymentSummaries: 'getPaymentSummaries',
            fetchInitialResume: 'fetchInitialResume',
            setInfoPaymentSummaries: 'setInfoPaymentSummaries',
            setPaymentSummaries: 'setPaymentSummaries',
            setTotalCustomerSummaries: 'setTotalCustomerSummaries',
            setDetailCustomerSummaries: 'setDetailCustomerSummaries',
            setTotalEmployeeSummaries: 'setTotalEmployeeSummaries',
            setDetailEmployeeSummaries: 'setDetailEmployeeSummaries',
            setDetailEgressSummaries: 'setDetailEgressSummaries',
            printArqueo: 'printArqueo', // después cambiauthorizer nombre a inglés
            setTotalIncome: 'setTotalIncome',
            setInitialAmountCash: 'setInitialAmountCash',
        }),
        formatObjects: function(object, formatter) {
            let obj = JSON.parse(JSON.stringify(object))
            formatter.forEach(format => {
                obj[format.front] = obj[format.back]
                delete obj[format.back]
            })
            return obj
        },
        async checkKey() {
            let payload = this.fillSnack(
                'info',
                'Confirmando',
                'Confirmando datos Supervisor',
                true
            )
            this.initSnackbar(payload)
            let response = await this.authorize()
            this.resetSnackbarState()

            if (response.status === 'success') {
                let payloadSnack = this.fillSnack(
                    'warning',
                    'Generando Arqueo',
                    'Porvafor Espere',
                    true
                )
                this.initSnackbar(payloadSnack)
                let cashDesk = this.posCashDeskId
                let responseSummaries = await this.getPaymentSummaries({
                    cashDesk: cashDesk,
                    authCode: this.uniqueKey,
                })
                let rs = { ...responseSummaries }
                console.log('response', rs.data.resume_pos_daily_cash)
                if (responseSummaries.status === 'success') {
                    let customer = this.formatObjects(
                        responseSummaries.data.resume_pos_daily_cash
                            .ingress_total_detail.customer_sales_total_detail,
                        responseCustomerFormat
                    )
                    let customerTotal =
                        responseSummaries.data.resume_pos_daily_cash
                            .ingress_total_detail.customer_sales_total
                    let employeeTotal =
                            responseSummaries.data.resume_pos_daily_cash
                                .ingress_total_detail.employee_sales_total,
                        employeeTotalResponse
                    let employee = this.formatObjects(
                        responseSummaries.data.resume_pos_daily_cash
                            .ingress_total_detail.employee_sales_total_detail,
                        responseEmployeeFormat
                    )
                    let egress = this.formatObjects(
                        responseSummaries.data.resume_pos_daily_cash
                            .egress_total_detail,
                        responseEgressTotal
                    )
                    let income =
                        responseSummaries.data.resume_pos_daily_cash
                            .ingress_total_detail
                    let initialAmountCash =
                        responseSummaries.data.resume_pos_daily_cash
                            .ingress_total_detail.initial_amount_cash

                    let payloadSnack = this.fillSnack(
                        'success',
                        'Arqueo',
                        'Generado Exitosamente',
                        false,
                        2000
                    )

                    this.setTotalCustomerSummaries(customerTotal)
                    this.setDetailCustomerSummaries(customer)
                    this.setTotalEmployeeSummaries(employeeTotal)
                    this.setDetailEmployeeSummaries(employee)
                    this.setDetailEgressSummaries(egress)
                    this.setTotalIncome(income)
                    this.resetSnackbarState()
                    this.initSnackbar(payloadSnack)
                    this.showTotalPaymentSummaries = true
                    this.printArqueo()
                    this.$router.push('/')
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error al generar Arqueo',
                        responseSummaries.statusText,
                        false,
                        2000
                    )
                    this.initSnackbar(payload)
                }
            } else {
                //console.log(response,'validcode')
                let payload = this.fillSnack(
                    'error',
                    'Error Codigo',
                    response.message,
                    false,
                    2000
                )
                console.log(payload, 'snack')
                this.initSnackbar(payload)
            }
        },
    },
    watch: {},
    components: {
        'total-summaries': TotalDetailSummaries,
        'information-summaries': InformationSummaries,
        'modal-supervisor': ModalSupervisor,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        let handleConfirmation = e => {
            if (e.keyCode !== 119) return
            this.openModal = false
            setTimeout(() => {
                this.openModal = true
            }, 50)
        }
        window.addEventListener('keydown', handleConfirmation)
    },
    // beforeMount: function(){...},
    mounted: async function() {
        this.setPermission('authorize daily_cash')
        let response = await this.fetchInitialResume(this.posCashDeskId)
        this.resetSnackbarState()
        if (response.status == 'success') {
            this.setInfoPaymentSummaries(response.data.resume_pos_daily_cash)
        }
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.colorBackGround {
    background: aliceblue;
}
.informationSummaries {
    font-size: 18px;
    font-weight: bold;
    margin-left: -30px;
}
.box {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
